import React, { useEffect } from "react";
import Common_title from "../common-components/common-title/Common_title";
import { useDispatch, useSelector } from "react-redux";
import { getReturn_Policy } from "../../features/returnpolicy/Slice";

const Refund_Policy = () => {
  const dispatch = useDispatch();
  const refundspolicy = useSelector(
    (state) => state.returnpolicy.addReturnPolicy
  );

  useEffect(() => {
    dispatch(getReturn_Policy());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <section className="Terms_Conditions">
      <div className="container-fluid">
        <Common_title title="Refund" titleblack="Policy" />
        <div className="content_div">
          {refundspolicy && refundspolicy.content ? (
            <div
              className="description_text"
              dangerouslySetInnerHTML={{ __html: refundspolicy.content }}
            />
          ) : (
            <p className="no-data">No Refund Policy Available</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Refund_Policy;
